import React, { useState } from "react";
import NavBar from './Navbar/NavBar';
import CareerForm from "./CareerForm";
import { FaExternalLinkAlt } from "react-icons/fa";
import CareerSvg from '../images/carrer.svg';
import SectionHeading from "./SectionHeading";

const Career = () => {
  const [showForm, setShowForm] = useState(false);

  return (
    <div id="career" className="bg-gray-50 pt-24 pb-16 md:pb-20">
        <NavBar />
        <section data-aos="zoom-in-down" className="container-app">
            <SectionHeading eyebrow="Bergabung Bersama Kami" title="Karir" />

            <div className="flex flex-col items-center justify-center">
                <p className="max-w-3xl mx-auto text-center text-slate-600 leading-relaxed">
                    PT. BERANI SETIA WASPADA membuka peluang karir bagi individu yang bersemangat, berdedikasi, dan siap berkontribusi dalam menciptakan lingkungan kerja yang aman dan nyaman bagi klien kami. Kami percaya bahwa sumber daya manusia adalah aset terpenting dalam mencapai kesuksesan. Jika Anda memiliki passion di bidang keamanan, kebersihan, atau administrasi, kami mengundang Anda untuk bergabung dengan tim profesional kami.
                </p>

                <div className="flex items-center justify-center mt-10 w-full">
                    <div className="bg-brand text-white p-6 md:p-8 rounded-2xl flex flex-col lg:flex-row items-center gap-6 max-w-4xl mx-auto shadow-card">
                        <div className="w-full lg:w-1/2 flex justify-center">
                            <img
                                src={CareerSvg}
                                alt="Security Officers"
                                className="w-[200px] h-auto object-contain"
                            />
                        </div>

                        <div className="w-full lg:w-1/2 text-center lg:text-left">
                            <h3 className="text-xl font-bold mb-2">Bergabung Bersama Kami</h3>
                            <p className="text-sm leading-relaxed text-white/85">
                                PT. BERANI SETIA WASPADA membuka peluang karir bagi Anda yang bersemangat dan berdedikasi di bidang keamanan, kebersihan, dan administrasi.
                            </p>

                            <div className="mt-5 flex justify-center lg:justify-start">
                                <button
                                    type="button"
                                    onClick={() => setShowForm(true)}
                                    className="bg-white text-brand font-semibold py-2.5 px-5 rounded-lg flex items-center gap-2 justify-center transition-transform duration-200 hover:shadow-md active:scale-[0.98] cursor-pointer"
                                >
                                    Kirim Lamaran <FaExternalLinkAlt className="text-sm" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* Tampilkan Pop-up Form */}
        {showForm && <CareerForm onClose={() => setShowForm(false)} />}
    </div>
  );
};

export default Career;
